import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createDeposit, listDistributor } from '@/api/deposit.js';
import { listPayType } from '@/api/dict.js';
import dayjs from 'dayjs';
export default {
  components: {},
  data: function data() {
    return {
      dialogTitle: '',
      dialogVisible: false,
      form: {},
      formRules: {
        collectionCompanyName: [{
          required: true,
          message: '请输入收款公司',
          trigger: ['change', 'blur']
        }],
        collectionCompanyBank: [{
          required: true,
          message: '请输入开户银行',
          trigger: ['change', 'blur']
        }],
        collectionCompanyBankAccount: [{
          required: true,
          message: '请输入银行账号',
          trigger: ['change', 'blur']
        }],
        payType: [{
          required: true,
          message: '请选择付款方式',
          trigger: ['change', 'blur']
        }]
      },
      payTypeList: listPayType(),
      action: null,
      appRow: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    init: function init(appRow, action) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, manuRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.action = action;
                that.appRow = appRow;
                that.dialogVisible = true;
                that.dialogTitle = '退款申请';

                if (!appRow) {
                  _context.next = 13;
                  break;
                }

                console.log('appRow', appRow.pictureLicense);
                _context.next = 9;
                return listDistributor({
                  name: appRow.manuName,
                  isCashPledgeRecords: 1
                });

              case 9:
                manuRes = _context.sent;
                appRow.dealerProductPrice = manuRes.list[0].dealerProductPrice;
                appRow.dealerToolPrice = manuRes.list[0].dealerToolPrice;
                that.form = {
                  manuId: appRow.manuId,
                  dealerProductPrice: appRow.dealerProductPrice,
                  dealerToolPrice: appRow.dealerToolPrice,
                  productPrice: Math.abs(appRow.productPrice),
                  toolPrice: Math.abs(appRow.toolPrice),
                  payType: 1,
                  optionType: appRow.optionType,
                  // 1=增加 2=减少
                  receiptTime: dayjs(appRow.receiptTime).format('YYYY-MM-DD'),
                  mark: appRow.mark,
                  pictureLicense: appRow.pictureLicense,
                  // 凭证
                  collectionCompanyId: appRow.collectionCompanyId,
                  // 付款公司ID
                  collectionCompanyName: appRow.collectionCompanyName,
                  // 付款公司名称
                  collectionCompanyBank: appRow.collectionCompanyBank,
                  // 银行名称
                  collectionCompanyBankAccount: appRow.collectionCompanyBankAccount,
                  // 银行账号
                  status: appRow.status,
                  source: appRow.source
                };

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.$emit('reload');
      that.dialogVisible = false;
    },
    formSubmit: function formSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this2;

                if (!(that.form.productPrice === 0 && that.form.toolPrice === 0)) {
                  _context3.next = 4;
                  break;
                }

                that.$message.error('货款押金退款金额/工具押金退款金额，不能同时为0');
                return _context3.abrupt("return");

              case 4:
                that.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid, err) {
                    var loading, form, item;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 18;
                              break;
                            }

                            loading = _this2.$loading({
                              text: 'Loading...',
                              spinner: 'el-icon-loading',
                              background: 'rgba(0, 0, 0, 0.7)'
                            });
                            _context2.prev = 2;
                            form = JSON.parse(JSON.stringify(that.form));
                            form.status = 2;
                            form.pictureLicense = form.pictureLicense ? JSON.stringify(form.pictureLicense) : '[]';
                            _context2.next = 8;
                            return createDeposit(form);

                          case 8:
                            that.$notify.success('退款申请成功！');
                            that.dialogClose();
                            _context2.next = 15;
                            break;

                          case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2["catch"](2);
                            console.log(_context2.t0.message);

                          case 15:
                            loading.close();
                            _context2.next = 25;
                            break;

                          case 18:
                            _context2.t1 = regeneratorRuntime.keys(err);

                          case 19:
                            if ((_context2.t2 = _context2.t1()).done) {
                              _context2.next = 25;
                              break;
                            }

                            item = _context2.t2.value;

                            _this2.$message.error(err[item][0].message);

                            return _context2.abrupt("return");

                          case 25:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[2, 12]]);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    payTypeFormatter: function payTypeFormatter(payType) {
      var that = this;
      var findRow = that.payTypeList.find(function (item) {
        return item.ID === payType;
      });

      if (findRow) {
        return findRow.name;
      } else {
        return payType;
      }
    },
    moneyFormatter: function moneyFormatter(val) {
      return Number(val).toFixed(2);
    },
    reEdit: function reEdit() {
      var that = this;
      that.action = 'EDIT';
      that.status = 1;
    }
  }
};